"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccordionSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _rawAccordion = require("./raw-accordion");

var AccordionSize;
exports.AccordionSize = AccordionSize;

(function (AccordionSize) {
  AccordionSize["Small"] = "small";
  AccordionSize["Medium"] = "medium";
})(AccordionSize || (exports.AccordionSize = AccordionSize = {}));

/** An accordion component with internal state */
var Accordion = function Accordion(props) {
  var _useState = (0, _react.useState)(Boolean(props.visible || props.initiallyExpanded)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var onClick = function onClick() {
    setExpanded(!expanded);

    if (props.onClick) {
      props.onClick();
    }
  };

  return _react["default"].createElement(_rawAccordion.RawAccordion, (0, _extends2["default"])({}, props, {
    expanded: expanded,
    onClick: onClick
  }));
};

var _default = Accordion;
exports["default"] = _default;